import { useToasts } from '@/lib/toast';
import { usePermissions } from '@/lib/useCurrentUser';
import { useResumeSuggestion } from '@/features/time-tracking/resumeSuggestion';
import { useRunningTimer, useStopTimer } from '@/features/time-tracking/timeTrackingApi';

/**
 * Laufender Timer + „Stoppen" mit „Fortsetzen"-Vorschlag — geteilt von der
 * Timer-Pille im Kopf und dem „+"-Sheet der mobilen Leiste, damit beide gleich
 * stoppen (Vorschlag merken, Meldung zeigen).
 */
export function useStopRunningTimer() {
  const { can } = usePermissions();
  const isAllowed = can('timetracking.read');
  const { data } = useRunningTimer(isAllowed);
  const stopTimer = useStopTimer();
  const remember = useResumeSuggestion((state) => state.remember);
  const push = useToasts((state) => state.push);
  const running = data?.data ?? null;
  const isRunning = Boolean(running?.startTime);

  async function stop(): Promise<void> {
    // Vor dem Stoppen merken: Danach ist der laufende Eintrag weg.
    const stopped = running;
    try {
      await stopTimer.mutateAsync({});
      push('success', 'Timer gestoppt.');
      if (stopped) remember(stopped);
    } catch (error) {
      push('danger', error instanceof Error ? error.message : 'Timer konnte nicht gestoppt werden.');
    }
  }

  return { isAllowed, running, isRunning, stop, isStopping: stopTimer.isPending };
}
